import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import Earning from "./Earning";

const EarningLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Earning" />
      <Earning />
    </MasterLayout>
  );
};

export default EarningLayout;
